<template>
    <div class="historico-beneficiarios px-4">
        <div class="table-container">
            <b-table id="historico-beneficiarios-temp" striped responsive :items="rows" :fields="headerFields">
                <template v-slot:cell(status)="{ item }">
                    <div class="status" :class="getStatusClass(item.status)">
                        {{item.status}}
                    </div>
                </template>
                <template v-slot:cell(id)="{ item }">
                    <ButtonContainer>
                        <ButtonEditTable :id="item.id" :titleTooltip="'Editar ' + (item.tipoId == TITULAR ? 'Funcionário' : 'Dependente')" @click="edit(item)"/>
                        <ButtonAddUserTable :id="item.id" :titleTooltip="'Cadastrar Dependente'" @click="add(item)" v-if="item.tipoId == TITULAR && item.flgAtivacao == 1"/>
                        <ButtonRemoveUserTable :id="item.id" :titleTooltip="'Inativar ' + (item.tipoId == TITULAR ? 'Funcionário' : 'Dependente')" @click="inativar(item)" v-show="item.flgAtivacao == 1"/>
                    </ButtonContainer>
                </template>
            </b-table>
        </div>
        <ModalCadastrarBeneficiario v-if="modal" @close="closeModal" :beneficiario="beneficiario" :acao="acao"></ModalCadastrarBeneficiario>
        <ModalInativarBeneficiario v-if="modalInativar" @close="closeModal" :beneficiario="beneficiario"></ModalInativarBeneficiario>
    </div>
</template>

<script>

let headerFields = [
    {key: 'nome', label: "Nome", thClass: 'px-2', tdClass: 'px-2'},
    {key: 'cpf', label: 'CPF', thClass: 'px-2', tdClass: 'px-2'},
    {key: 'produto', label: 'Serviço', thClass: 'px-2', tdClass: 'px-2'},
    {key: 'tipo', label: 'Tipo', thClass: 'px-2', tdClass: 'px-2'},
    {key: 'data', label: 'Data de cadastro', thClass: 'px-2', tdClass: 'px-2'},
    {key: 'responsavel', label: 'Responsável', thClass: 'px-2', tdClass: 'px-2'},
    {key: 'status', label: 'Status', thClass: 'px-2', tdClass: 'px-2'},
    {key: 'id', label: 'Ações', thClass: 'px-2', tdClass: 'px-2'},
]

let columnsKeys = [
    'nome',
    'cpf',
    'produto',
    'tipo',
    'id',
    'data',
    'responsavel',
    'status',
]

import ModalCadastrarBeneficiario from './ModalCadastrarBeneficiario.vue'
import ModalInativarBeneficiario from './ModalInativarBeneficiario.vue'
import ButtonContainer from "@/components/commons/table/components/ButtonContainer.vue";
import ButtonEditTable from "@/components/commons/table/components/ButtonEditTable.vue";
import ButtonAddUserTable from "@/components/commons/table/components/ButtonAddUserTable.vue";
import ButtonRemoveUserTable from "@/components/commons/table/components/ButtonRemoveUserTable.vue";

export default {
    name: "HistoricoBeneficiarioList",
    components:{
      ModalCadastrarBeneficiario,
      ModalInativarBeneficiario,
      ButtonContainer,
      ButtonEditTable,
      ButtonAddUserTable,
      ButtonRemoveUserTable
    },
    props: {
		rows: Array
	},
    data() {
        return {
            TITULAR : 1,
            beneficiario: null,
            acao: null,
            modal: null,
            modalInativar: null,
            headerFields: [
                ...headerFields.filter(head => columnsKeys.includes(head.key)),
            ],
            lastFilter: {},
            page: 1,
        }

    },
    methods:{
        add (beneficiario) {
            this.beneficiario = beneficiario
            this.acao ="CADASTRAR"
            this.modal = true
        },
        edit(beneficiario) {
            this.beneficiario = beneficiario
            this.acao ="EDITAR"
            this.modal = true
        },
        inativar(beneficiario) {
            this.modalInativar = true
            this.beneficiario = beneficiario
        },
        getStatusClass( status ){
            switch(status){
                case "Ativo": return "active"
                case "Inativo": return "inative"
            }
        },
        closeModal(){
            this.modal = null
            this.modalInativar = null
            this.$emit("filtrar")
        }
    }
}
</script>